import { Trans } from '@lingui/react/macro';

import { CustomOrganizationPrice } from '@/api';
import Button from '@/design_system/Button';
import Tooltip from '@/design_system/Tooltip';
import IconInfo from '@/icons/Info.svg';
import { useRequestContext } from '@/routes/Requests/contexts/RequestContext';

export const MarginTooltip = ({
  customOrganizationPrice,
}: {
  customOrganizationPrice: CustomOrganizationPrice | null | undefined;
}) => {
  const { view } = useRequestContext();

  const workshopPriceLabel = view.workshopPrice.labelWithoutVATInfo;
  const margin = customOrganizationPrice?.margin;

  if (!margin) {
    return null;
  }

  return (
    <Tooltip
      content={
        <>
          <Trans id="article.margin-tooltip.line-1">Auto-calculated price:</Trans>
          <br />
          <Trans id="article.margin-tooltip.line-2">
            {workshopPriceLabel} + {margin}% margin
          </Trans>
        </>
      }
    >
      <Button variant="style-less">
        <IconInfo style={{ fontSize: '1rem', color: 'var(--color-text-disabled-black)' }} />
      </Button>
    </Tooltip>
  );
};
